import React from 'react';
import { useShowEpics } from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import type { Card } from '../../../../../model/types';
import type { ScreenSize } from '../../../hooks/common/constants';
import { EpicLite } from '../index';

type Props = {
	card: Card;
	backlogContainerSize: ScreenSize | undefined;
	isCompactView: boolean;
	isSubtask: boolean;
};

export const EpicLiteWrapper = ({ card, backlogContainerSize, isCompactView }: Props) => {
	const showEpics = useShowEpics();

	if (showEpics) {
		return <EpicLite card={card} screenSize={backlogContainerSize} isCompactView={isCompactView} />;
	}
	return null;
};
